export default __webpack_public_path__ + "static/media/office365-logo.17849adf.svg";